import 'core-js/es';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import './assets/cssFiles/app.css';
import './assets/cssFiles/commonComponents.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './pages/App';
import ScrollTop from './components/ScrollTop';

ReactDOM.render(
    <BrowserRouter>
        <ScrollTop>
            <App />
        </ScrollTop>
    </BrowserRouter>, 
document.getElementById('root'));
